import React from "react";
import aboutImg from "../../assets/images/about/aboutImg.webp";
import leader1 from "../../assets/images/about/l1.png";
import leader2 from "../../assets/images/about/l2.png";
import st1 from "../../assets/images/about/st1.webp";
import st2 from "../../assets/images/about/st2.webp";
import Vector1 from "../../assets/images/about/Vector 10.png";
import Vector2 from "../../assets/images/about/Vector 11.png";
import Vector3 from "../../assets/images/about/Vector 12.png";

const About = () => {
  return (
    <div className="bg-white tracking-wide text-primaryTextColor font-sans px-4 sm:px-6 lg:px-12 py-12">
      {/* Header Section */}
      <section className="text-center lg:text-left">
        <h2
          style={{ lineHeight: "1.2" }}
          className="text-2xl sm:text-3xl md:text-5xl font-bold mb-4"
        >
          <span className="text-[#BDD0C7] font-semibold">
            Our Story and About :
          </span>{" "}
          <span className="text-primaryTextColor">
            Helping Businesses Thrive Through Innovative Financial Solutions.
          </span>
        </h2>
        <div className="w-full flex justify-end">
          <p className="text-secondaryTextColor max-w-4xl mx-auto lg:mx-0 text-lg leading-relaxed">
            TechSpear Ventures Is A Leading Finance And Business Consulting Firm
            Dedicated To Empowering Businesses With Innovative Financial
            Solutions. Our Mission Is To Help Clients Navigate The Complexities
            Of Finance, Optimize Their Operations, And Achieve Sustainable
            Growth.
          </p>
        </div>
      </section>

      {/* Main Image */}
      <section className="w-full pt-8 pb-16">
        <img
          src={aboutImg}
          alt="Business Meeting"
          className="w-full rounded-xl object-cover"
        />
      </section>

      {/* Stats Section */}
      <section className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center mb-16">
        {[
          { label: "Founded In", value: "2023" },
          { label: "Location", value: "Georgia" },
          { label: "Happy Clients", value: "100" },
          { label: "Investors", value: "50+" },
        ].map((item, i) => (
          <div key={i}>
            <p className="text-secondaryTextColor text-lg mb-2">{item.label}</p>
            <p className="text-3xl sm:text-4xl md:text-6xl font-bold text-primaryBtnColor">
              {item.value}
            </p>
          </div>
        ))}
      </section>

      {/* Leadership Section */}
      <section className="bg-[#FFF9F9] text-primaryTextColor p-6 md:p-16 mb-8 rounded-lg">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Section - Heading & Description */}
          <div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
              Our Leaders
            </h2>
            <p className="text-secondaryTextColor text-lg leading-relaxed">
              With a focus on integrity and collaboration, we ensure that our
              clients receive tailored strategies that drive success in today’s
              dynamic market. Our approach combines deep industry expertise,
              data-driven insights, and innovative solutions to deliver
              measurable results and long-term growth. By fostering transparent
              partnerships, we empower businesses to adapt, thrive, and achieve
              sustainable competitive advantage.
            </p>
          </div>

          {/* Right Section - Two Images with Name & Role */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {/* Card 1 */}
            <div className="text-center">
              <img
                src={leader1}
                alt="Team Member"
                className="w-full h-80 object-cover rounded-xl shadow-md"
              />
              <h4 className="mt-4 text-lg font-semibold">Srikant Sahoo</h4>
              <p className="text-secondaryTextColor text-sm">
                CEO & Co-Founder
              </p>
            </div>

            {/* Card 2 */}
            <div className="text-center">
              <img
                src={leader2}
                alt="Team Member"
                className="w-full h-80 object-cover rounded-xl shadow-md"
              />
              <h4 className="mt-4 text-lg font-semibold">Arpit Ku. Nayak</h4>
              <p className="text-secondaryTextColor text-sm">
                CMO & Co-Founder
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Strategy Section */}
      <section className="bg-white pb-16">
        <h2
          style={{ lineHeight: "1.2" }}
          className="w-full md:w-1/2 text-2xl sm:text-3xl md:text-4xl font-bold mb-8"
        >
          Creating Strategies to Optimize Performance Efficiently.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
          {/* Section 1 - Image */}
          <div className="h-full">
            <img
              src={st1}
              alt="Team img 1"
              className="w-full h-full object-cover rounded-xl shadow-md"
            />
          </div>

          {/* Section 2 - Image */}
          <div className="h-full">
            <img
              src={st2}
              alt="Team img 2"
              className="w-full h-full object-cover rounded-xl shadow-md"
            />
          </div>

          {/* Section 3 - Two Rows */}
          <div className="flex flex-col justify-between h-full">
            <div className="flex flex-col justify-center flex-1 space-y-4 bg-[#F6F9F1] p-4 md:p-8 rounded-lg">
              <div className="text-primaryBtnColor text-4xl md:text-5xl font-bold">
                5x
              </div>
              <div>
                <h4 className="text-2xl font-semibold text-primaryTextColor mb-2">
                  Strong Expertise
                </h4>
                <p className="text-secondaryTextColor text-lg leading-relaxed">
                  Our team brings years of experience to help businesses succeed
                  with strategic solutions.
                </p>
              </div>
            </div>

            <div className="flex flex-col justify-center flex-1 space-y-4 bg-[#CEF5A4] p-4 md:p-8 rounded-lg mt-8">
              <div className="text-primaryBtnColor text-4xl md:text-5xl font-bold">
                5x
              </div>
              <div>
                <h4 className="text-2xl font-semibold text-primaryTextColor mb-2">
                  Proven Results
                </h4>
                <p className="text-secondaryTextColor text-lg leading-relaxed">
                  We have a strong track record of delivering measurable
                  outcomes for our clients.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="bg-white pb-8">
        <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-bold mb-8">
          Join Our Mission
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
          {[
            {
              title: "Dynamic environment",
              desc: "We provide tailored solutions for every business need",
              icon: Vector1,
            },
            {
              title: "Professional development",
              desc: "We help businesses build financial plans aligned with their goals.",
              icon: Vector2,
            },
            {
              title: "Financial consulting",
              desc: "We streamline operations and cut costs through process optimization.",
              icon: Vector3,
            },
          ].map((item, i) => (
            <div key={i} className="px-6">
              <div className="mb-4 flex justify-center">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="w-16 h-16 object-contain" // Adjust size as needed
                />
              </div>
              <h4 className="text-2xl font-semibold text-primaryTextColor mb-2">
                {item.title}
              </h4>
              <p className="text-secondaryTextColor text-lg leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
